"use client";

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts?.map(function ({
        id,
        title,
        description,
        action,
        ...props
      }: {
        id: string;
        title: string;
        description: string;
        action: string;
        [key: string]: any;
      }) {
        return (
          <Toast
            className={"bg-primary"}
            variant={undefined}
            key={id}
            {...props}
          >
            <div className="grid gap-1">
              {title && (
                <ToastTitle className={""} props={[]}>
                  {title}
                </ToastTitle>
              )}
              {description && (
                <ToastDescription className={""} props={[]}>
                  {description}
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose className={""} />
          </Toast>
        );
      })}
      <ToastViewport className={""} />
    </ToastProvider>
  );
}
